<template>
    <div id="Articles">
        <CreateArticles
            v-if="showCreateArticles"
            :storyId="storyId"
            @close="showCreateArticles = false"
            @save="saveArticle"
        />
        <template v-else>
            <PreviewArticles
                :knowledge-base="showingContent"
                v-if="showingContent"
                @close="showingContent = null"
                :story-id="storyId"
                @deleted="() => onDeletedSingle(showingContent._id)"
                @changed="(enabled) => onChangedStateSingle(showingContent._id, enabled)"
            />
            <div class="article-container" v-else-if="!showingContent">
                <div class="header">
                    <div class="title">Articles</div>
                    <div class="actions">
                        <SupsisButton primary @click="showCreateArticles = true">
                            <i class="material-icons">add</i>
                            <span>Add content</span>
                        </SupsisButton>
                    </div>
                </div>
                <div>
                    <ve-pagination
                        :total="total"
                        :page-index="page"
                        :page-size="pageSize"
                        :page-size-option="[10, 15, 20, 50, 100]"
                        @on-page-number-change="(val) => (page = val)"
                        @on-page-size-change="(val) => (pageSize = val)"
                    />
                </div>
                <div class="content">
                    <div class="article-table">
                        <div class="article-table-header">
                            <div
                                class="article-table-header-item"
                                v-for="column in columns"
                                :key="column.id"
                                :style="{
                                    flex: column.flex,
                                    width: column.width ? column.width + 'px' : 'auto',
                                    'max-width': column.maxWidth ? column.maxWidth + 'px' : 'auto',
                                }"
                            >
                                <a-checkbox
                                    v-if="column.isCheckbox"
                                    @click="toggleSelectAll"
                                    :checked="isSelectAll()"
                                />
                                <template v-else>{{ column.title }}</template>
                            </div>
                        </div>
                        <div class="article-table-body">
                            <div class="row" v-for="row in filteredRows" :key="row._id">
                                <div
                                    class="cell"
                                    v-for="column in columns"
                                    :key="column.id"
                                    :style="{
                                        flex: column.flex,
                                        width: column.width ? column.width + 'px' : 'auto',
                                        'max-width': column.maxWidth ? column.maxWidth + 'px' : 'auto',
                                    }"
                                    @click="previewArticles(row)"
                                >
                                    <template v-if="column.slot === 'state'">
                                        <div class="d-flex w-100">
                                            <div v-if="row.enabled" class="state-cell active">Used by AI</div>
                                            <div v-else class="state-cell passive">Not used</div>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <template v-if="column.isCheckbox">
                                            <a-checkbox
                                                @click.stop="previewArticles(row)"
                                                :checked="isSelected(row)"
                                                @click="() => toggleSelect(row)"
                                            />
                                        </template>
                                        <template v-else>
                                            <span v-if="column.getData">{{ column.getData(row) }}</span>
                                            <span v-else>{{ row[column.id] }}</span>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="select-panel-wrapper" v-if="selectedItems.length">
                        <div class="select-panel">
                            <div class="items-count">
                                <i class="material-icons spin" v-if="busy">"autorenew"</i>
                                <i class="material-icons" v-else>check</i>
                                <div>{{ selectedItems.length }} selected</div>
                            </div>
                            <div class="buttons">
                                <SupsisButton small :disabled="busy" @click="() => deleteMulti()"
                                ><i class="material-icons">delete</i>
                                </SupsisButton>
                                <SupsisButton small :disabled="busy"
                                ><i class="material-icons">refresh</i></SupsisButton
                                >
                                <SupsisButton :disabled="busy" @click="() => multiChangeState(false)">
                                    <i class="material-icons">toggle_off</i>
                                    Disable AI
                                </SupsisButton>
                                <SupsisButton :disabled="busy" @click="() => multiChangeState(true)">
                                    <i class="material-icons">toggle_on</i>
                                    Enable AI
                                </SupsisButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ComingSoon from "../ComingSoon.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import CreateArticles from "./CreateArticles.vue";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import moment from "moment";
import PreviewArticles from "./PreviewArticles.vue";
import ContentPreview from "../ContentPreview.vue";
import { sendSocketMessage } from "../../../../../utils/socketStream";

export default {
    name: "Articles",
    components: {
        ContentPreview,
        SupsisButton,
        ComingSoon,
        CreateArticles,
        PreviewArticles,
    },
    props: {
        storyId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            total: 0,
            page: 1,
            pageSize: 10,
            showingContent: null,
            showCreateArticles: false,
            selectedItems: [],
            columns: [
                {
                    title: "",
                    id: "checkbox",
                    isCheckbox: true,
                    width: 50,
                    maxWidth: 50,
                },
                {
                    title: "Title",
                    id: "article.title",
                    flex: 2,
                    getData: (row) => {
                        return row.article?.title;
                    },
                },
                {
                    title: "Created At",
                    id: "createdAt",
                    getData: (row) => {
                        return moment(row.createdAt).format("DD/MM/YYYY");
                    },
                },
                {
                    title: "State",
                    id: "state",
                    slot: "state",
                },
            ],
            rows: [],
            loading: true,
            busy: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
        filteredRows() {
            return this.rows.filter(row => row.article && row.article.title);
        },
    },
    methods: {
        ...mapActions({}),
        selectAll() {
            this.selectedItems = this.rows;
        },
        deselectAll() {
            this.selectedItems = [];
        },
        isSelectAll() {
            return this.selectedItems.length === this.rows.length;
        },
        toggleSelectAll() {
            if (this.selectedItems.length === this.rows.length) {
                this.deselectAll();
            } else {
                this.selectAll();
            }
        },
        toggleSelect(item) {
            const isSelected = this.selectedItems.find((i) => i._id === item._id);
            if (isSelected) {
                this.selectedItems = this.selectedItems.filter((i) => i._id !== item._id);
            } else {
                this.selectedItems.push(item);
            }
        },
        isSelected(item) {
            return !!this.selectedItems.find((i) => i._id === item._id);
        },
        reTrain() {
            sendSocketMessage("chatbot/v2 complete-train", {
                siteId: this.site._id,
                storyId: this.storyId,
                pageIds: [],
            });
        },
        fetch(page, pageSize) {
            this.loading = true;
            CHATBOT_API.KNOWLEDGE_BASE.listKnowledgeBase(this.storyId, "article", page, pageSize).then((res) => {
                this.rows = res.data.rows;
                this.total = res.data.total;
                this.loading = false;
            });
        },
        onDeletedSingle(id) {
            sendSocketMessage("chatbot/v2 kb-article-removed", {
                siteId: this.site._id,
                storyId: this.storyId,
                ids: [id],
            });
            this.fetch();
        },
        onChangedStateSingle(id, enabled) {
            this.$message.success(
                enabled ? "Selected knowledge bases are enabled." : "Selected knowledge bases are disabled.",
            );
            this.rows = this.rows.map((x) => {
                if (x._id === id) {
                    x.enabled = enabled;
                }
                return x;
            });
            this.selectedItems = [];
            this.reTrain();
            this.$emit("trained");
            this.showingContent = null;
        },
        onDeletedMulti(ids) {
            sendSocketMessage("chatbot/v2 kb-article-removed", {
                siteId: this.site._id,
                storyId: this.storyId,
                ids: ids,
            });
        },
        deleteMulti() {
            const selectedIds = this.selectedItems.map((i) => i._id);
            this.busy = true;
            const hide = this.$message.loading("Selected knowledge bases are being deleted...", 0);
            CHATBOT_API.KNOWLEDGE_BASE.deleteMultiKnowledgeBase(this.storyId, selectedIds)
                .then(() => {
                    this.onDeletedMulti(selectedIds);
                    this.$message.success("Selected knowledge bases are deleted.");
                    this.selectedItems = [];
                    this.reTrain();
                    this.rows = this.rows.filter((i) => !selectedIds.includes(i._id));
                    this.$emit("trained");
                    this.fetch();
                })
                .catch((error) => {
                    this.$message.error("Selected knowledge bases are not deleted. Please try again.");
                })
                .finally(() => {
                    this.busy = false;
                    hide();
                });
        },
        multiChangeState(enabled) {
            const selectedIds = this.selectedItems.map((i) => i._id);
            this.busy = true;
            const hide = this.$message.loading(
                enabled
                    ? "Selected knowledge bases are being enabled..."
                    : "Selected knowledge bases are being disabled...",
                0,
            );
            CHATBOT_API.KNOWLEDGE_BASE.changeStateMultiKnowledgeBase(this.storyId, selectedIds, enabled)
                .then((isSuccess) => {
                    if (!isSuccess) return Promise.reject("Failed to change state.");
                    this.$message.success(
                        enabled ? "Selected knowledge bases are enabled." : "Selected knowledge bases are disabled.",
                    );
                    this.selectedItems = [];
                    this.reTrain();
                    this.fetch();
                    this.$emit("trained");
                    if (enabled === false) {
                        sendSocketMessage("chatbot/v2 kb-article-removed", {
                            siteId: this.site._id,
                            storyId: this.storyId,
                            ids: [...selectedIds],
                        });
                    }
                    if (enabled === true) {
                        sendSocketMessage("chatbot/v2 kb-article-added", {
                            siteId: this.site._id,
                            storyId: this.storyId,
                            ids: [...selectedIds],
                        });
                    }
                })
                .catch((error) => {
                    this.$message.error(
                        enabled
                            ? "Selected knowledge bases are not enabled."
                            : "Selected knowledge bases are not disabled.",
                    );
                })
                .finally(() => {
                    this.busy = false;
                    hide();
                });
        },
        previewArticles(row) {
            this.showingContent = row;
            this.showCreateArticles = false;
        },
        async saveArticle(payload) {
            const kb = await CHATBOT_API.KNOWLEDGE_BASE.createKnowledgeBase(
                this.storyId,
                "article",
                undefined,
                undefined,
                undefined,
                {
                    title: payload.title,
                    content: payload.content,
                }).then((res) => res.data);
            this.rows.push(kb);
            sendSocketMessage("chatbot/v2 kb-article-added", {
                siteId: this.site._id,
                storyId: this.storyId,
                ids: [kb._id],
            });
            this.$message.success("Article created successfully");
            this.showCreateArticles = false;
            this.fetch();
        },
        async updateArticlee(id, payload) {
            await CHATBOT_API.KNOWLEDGE_BASE.knowledgeBaseUpdate(this.storyId, id, payload)
                .then((res) => res.data)
                .then((data) => {
                    this.rows = this.rows.map((row) => {
                        if (row._id === id) row = data;
                        return row;
                    });
                    this.showingContent = null;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        page() {
            this.fetch(this.page, this.pageSize);
        },
        pageSize() {
            this.fetch(this.page, this.pageSize);
        },
    },
};
</script>
<style lang="scss" scoped>
#Articles {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    width: 100%;
    height: 100%;
    .article-container {
        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 0px;
            width: 100%;

            .title {
                color: #22272d;
                display: flex;
                font-size: 22px;
                font-weight: 600;
                line-height: 28px;
                align-items: center;
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 20px;
        }

        .article-table {
            width: 100%;

            .article-table-header {
                display: flex;
                align-items: center;
                width: 100%;
                padding: 10px;

                .article-table-header-item {
                    flex: 1;
                }
            }

            .article-table-body {
                display: flex;
                flex-direction: column;
                gap: 10px;
                width: 100%;
                align-items: center;
                overflow-y: auto;
                height: 100%;
                max-height: calc(100vh - 100px);

                .row {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                    padding: 10px;
                    border-radius: 5px;
                    background: var(--color-bg-neutral-default);
                    cursor: pointer;

                    &:hover {
                        opacity: 0.8;
                    }

                    .cell {
                        flex: 1;
                        color: #000;
                        font-size: 15px;
                        font-weight: 600;
                        line-height: 19px;
                        overflow: hidden !important;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .state-cell {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        font-weight: 600;
                        height: 32px;
                        justify-content: center;
                        line-height: 18px;
                        padding: 0 6px;
                        border-radius: 10px;

                        &.active {
                            background: #fff;
                            color: #00893c;
                            width: min-content;
                        }

                        &.passive {
                            background: #dcdcdc;
                            color: #79797c;
                            width: min-content;
                        }
                    }
                }
            }
        }

        .select-panel-wrapper {
            bottom: 10px;
            left: 36px;
            position: absolute;
            right: 36px;

            .select-panel {
                background: #22272d;
                border-radius: 15px;
                box-shadow: 0 -4px 32px 0 rgba(0, 0, 0, 0.16);
                color: #fff;
                height: 64px;
                align-items: center;
                display: flex;
                justify-content: center;

                .items-count {
                    align-items: center;
                    display: flex;
                    justify-content: center;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 20px;
                    margin-left: 16px;
                }

                .buttons {
                    align-items: center;
                    display: flex;
                    gap: 8px;
                    justify-content: center;
                    margin-left: auto;
                    margin-right: 16px;
                }
            }
        }
    }
}
</style>
